import React from 'react';
import { ThemeProvider } from './core/contexts/ThemeContext';
import { WindowProvider } from './core/contexts/WindowContext';
import { AppRegistryProvider } from './core/contexts/AppRegistry';
import { Desktop } from './components/OS/Desktop';
export function App() {
  return <ThemeProvider data-id="element-0">
      <WindowProvider data-id="element-1">
        <AppRegistryProvider data-id="element-2">
          <Desktop data-id="element-3" />
        </AppRegistryProvider>
      </WindowProvider>
    </ThemeProvider>;
}